<template>
<div class="chapter">
<div class="inner_page">
<div class="copyrightPage" id="cop1"><p class="copyrightext2"><span><img alt="logo" src="Images/logo.jpg"/></span></p><p class="copyrightext1"><span>1230 Avenue of the Americas</span></p><p class="copyrightext1"><span>New York, NY 10020</span></p><p class="copyrightText"><span>This book is a work of fiction. Names, characters, places and incidents are products of the author’s imagination or are used fictitiously. Any resemblance to actual events or locales or persons, living or dead, is entirely coincidental.</span></p><p class="copyrightText"><span>Copyright © 2002 by Brian McGrory</span></p><p class="copyrightText"><span>All rights reserved, including the right to reproduce this book or portions thereof in any form whatsoever. For information, address Atria Books, 1230 Avenue of the Americas, New York, NY 10020</span></p><p class="copyrightText"><span>ISBN-13:  978-0-7434-8362-9<br/>ISBN-10: 0-7434-8362-6</span></p><p class="copyrightText"><span><span class="bold"><span>ATRIA</span></span><span class="small">BOOKS</span> is a trademark of Simon &amp; Schuster, Inc.</span></p><p class="copyrightText"><span>Visit us on the World Wide Web:<br/>
<a href="http://www.SimonSays.com" target="_blank">http://www.SimonSays.com</a></span></p></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780743483629_cop1.vue?140ef428